module.exports = __webpack_public_path__ + "img/paste.70e167cd.svg";